import React from 'react';
import { Typography } from '@loomstateorg/shared-frontend';

interface Image {
  fields: {
    file: {
      url: string;
    };
  };
}
export interface CardProps {
  children?: React.ReactNode;

  image?: Image;
  subHeader: string;
  title: string;
  ecoParagraph: string;
  ctaLabel: string;
  ctaReference: string;
  paragraphWrapperClassName?: string;
  index?: number;
}

const Card: React.FC<CardProps> = ({
  image,
  subHeader,
  title,
  ecoParagraph,
  ctaLabel,
  ctaReference,
  paragraphWrapperClassName,
  index = 0,
}) => {
  return (
    <div className="margin flex w-full flex-col items-center" data-testid={`eco-card-${index}`}>
      {image ? (
        <img
          src={image?.fields?.file?.url}
          alt="Component Image"
          className="h-auto max-h-[9rem] w-full lg:max-h-[16rem]"
        />
      ) : (
        <div className="h-240 w-full bg-eco-light" />
      )}
      <div className="mt-15 flex w-full flex-col items-center">
        {title && (
          <Typography
            className="w-full text-center text-20 text-primary-regular lg:text-28"
            lineHeight="7"
            data-testid={`eco-card-title-${index}`}
          >
            {title}
          </Typography>
        )}
        {subHeader && (
          <Typography as="h3" className="mt-15 text-center text-14 font-semibold text-primary-regular lg:text-16">
            {subHeader}
          </Typography>
        )}
        {ecoParagraph && paragraphWrapperClassName && (
          <div className={paragraphWrapperClassName}>
            <Typography lineHeight="7" className="text-center text-12 capitalize text-primary-regular lg:text-14">
              {ecoParagraph}
            </Typography>
          </div>
        )}
        {ecoParagraph && !paragraphWrapperClassName && (
          <Typography
            as="span"
            lineHeight="7"
            className="mt-15 text-center text-12 capitalize text-primary-regular lg:text-14"
          >
            {ecoParagraph}
          </Typography>
        )}
        {ctaLabel && ctaReference && (
          <a
            href={ctaReference}
            className="mt-15 capitalize text-primary-regular underline"
            data-testid={`eco-card-cta-${index}`}
          >
            <Typography className="text-center text-12 lg:text-14">{ctaLabel}</Typography>
          </a>
        )}
      </div>
    </div>
  );
};

export default Card;
